var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 49,
    viewBox: "0 0 53 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9868 4.3425C29.9868 5.77242 29.126 7.0013 27.8944 7.53929V10.6189H43.2313C44.0045 10.6189 44.6313 11.2457 44.6313 12.0189V34.3238C44.6313 35.097 44.0045 35.7238 43.2313 35.7238H33.474V39.9077H36.2577C37.0309 39.9077 37.6577 40.5345 37.6577 41.3077V46.876C37.6577 47.6492 37.0309 48.276 36.2577 48.276H16.7422C15.969 48.276 15.3422 47.6492 15.3422 46.876V41.3077C15.3422 40.5345 15.969 39.9077 16.7422 39.9077H19.5269V35.7238H9.76866C8.99546 35.7238 8.36865 35.097 8.36865 34.3238V12.0189C8.36865 11.2457 8.99545 10.6189 9.76865 10.6189H25.105V7.53904C23.8737 7.00093 23.0132 5.7722 23.0132 4.3425C23.0132 2.4168 24.5743 0.855713 26.5 0.855713C28.4257 0.855713 29.9868 2.4168 29.9868 4.3425ZM22.3167 23.1713C22.3167 24.7118 21.0678 25.9607 19.5272 25.9607C17.9867 25.9607 16.7378 24.7118 16.7378 23.1713C16.7378 21.6307 17.9867 20.3818 19.5272 20.3818C21.0678 20.3818 22.3167 21.6307 22.3167 23.1713ZM33.4744 25.9607C35.015 25.9607 36.2638 24.7118 36.2638 23.1713C36.2638 21.6307 35.015 20.3818 33.4744 20.3818C31.9338 20.3818 30.685 21.6307 30.685 23.1713C30.685 24.7118 31.9338 25.9607 33.4744 25.9607Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4192 28.7503C50.5003 28.7503 52.9981 26.2525 52.9981 23.1714C52.9981 20.0903 50.5003 17.5925 47.4192 17.5925V28.7503Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57886 28.75C2.49774 28.75 -8.10623e-06 26.2523 -8.10623e-06 23.1712C-8.10623e-06 20.09 2.49774 17.5923 5.57886 17.5923V28.75Z",
    fill: "#6B7CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon 6.d07df3c0bd6a37b72fe0758f26cda651.svg";
export { ForwardRef as ReactComponent };